import styled from 'styled-components'
import { spacings } from 'styles/theme'

export const StoreCard = styled.div`
  display: inline-flex;
  align-items: center;

  button{
    margin-right: ${spacings.sl};
  }

  figure{
    width: 50px;
    height: auto;
    margin-right: ${spacings.sl};

    img{
      object-fit: cover;
      width: 100%;
      height: auto;
    }
  }
`
